export default __webpack_public_path__ + "static/media/favors-gifts.ce57d7fc.jpg";